import useSiteSettings from '../../hooks/useSiteSettings'
import { Copy, copyFor } from './copy'

/**
 * Copy for the locale this site is built for. `copyFor` returns a module-level constant, so there is
 * nothing here to memoize.
 */
export const useCopy = (): Copy => copyFor(useSiteSettings().lang)
